import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Chip, Stack } from '@mui/material';
import { FinanceDateType } from '@trnsact/trnsact-shared-types';
import { FinanceFilters, FinanceFilterType } from '../types';
import { DATE_RANGE_OPTIONS } from 'modules/finance/performance/constants';
import { FinanceDateRange } from 'modules/finance/performance/types';
import { DateTypeToggle } from 'modules/finance/ui/components/DateTypeToggle';

export const FinanceDealDateRange = () => {
  const { control, setValue } = useFormContext<FinanceFilters>();
  const current = useWatch({ control, name: FinanceFilterType.DEAL_DATE });
  const dateType = useWatch({ control, name: FinanceFilterType.DATE_TYPE });

  return (
    <Stack spacing={1.5}>
      <DateTypeToggle
        value={dateType ?? FinanceDateType.CreatedOn}
        onChange={v => setValue(FinanceFilterType.DATE_TYPE, v)}
      />

      <Stack direction="row" gap="0.5rem" flexWrap="wrap">
        {DATE_RANGE_OPTIONS.map(opt => (
          <Chip
            key={opt.value}
            label={opt.label}
            size="small"
            onClick={() => setValue(FinanceFilterType.DEAL_DATE, opt.value as FinanceDateRange)}
            variant={current === opt.value ? 'filled' : 'outlined'}
            color={current === opt.value ? 'primary' : 'default'}
            sx={{ fontSize: 11, fontWeight: 500, height: 26, cursor: 'pointer' }}
          />
        ))}
      </Stack>
    </Stack>
  );
};
